// Handles the UI for the grid view toggle on mobile devices.

$(document).on("click", ".single-view", function () {
  $("#js-collection-listings").addClass("collection__listings--single");
  $(".single-view").addClass("single-view--active");
  $(".double-view").removeClass("double-view--active");
});

$(document).on("click", ".double-view", function () {
  $("#js-collection-listings").removeClass("collection__listings--single");
  $(".double-view").addClass("double-view--active");
  $(".single-view").removeClass("single-view--active");
});
